/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiLedgerAccount, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of LedgerAccountsController.
 */
export class LedgerAccountsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /ledger_accounts:prefill
     */
    public createPrefilled(): Promise<Result<ApiLedgerAccount>> {
        return this.http.post<Result<ApiLedgerAccount>, undefined>('/ledger_accounts:prefill', undefined);
    }

    /**
     * Calls GET /ledger_accounts:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiLedgerAccount>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiLedgerAccount>>>('/ledger_accounts:query', query);
    }

    /**
     * Calls POST /ledger_accounts:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiLedgerAccount>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiLedgerAccount>>, ListRequest>('/ledger_accounts:query', listRequest, query);
    }

    /**
     * Calls GET /ledger_accounts/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiLedgerAccount>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiLedgerAccount>>(`/ledger_accounts/${primaryId}`, query);
    }

    /**
     * Calls POST /ledgeraccounts:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiLedgerAccount>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiLedgerAccount>>, ListRequestWithIds>('/ledgeraccounts:batch', listRequest, query);
    }

    /**
     * Calls POST /ledger_accounts
     */
    public add(dto: ApiLedgerAccount): Promise<Result<ApiLedgerAccount>> {
        return this.http.post<Result<ApiLedgerAccount>, ApiLedgerAccount>('/ledger_accounts', dto);
    }

    /**
     * Calls PUT /ledger_accounts/{primaryId}
     */
    public update(dto: ApiLedgerAccount, primaryId: string): Promise<Result<ApiLedgerAccount>> {
        return this.http.put<Result<ApiLedgerAccount>, ApiLedgerAccount>(`/ledger_accounts/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /ledger_accounts
     */
    public putRange(dtos: ApiLedgerAccount[]): Promise<Result<ApiLedgerAccount[]>> {
        return this.http.patch<Result<ApiLedgerAccount[]>, ApiLedgerAccount[]>('/ledger_accounts', dtos);
    }

    /**
     * Calls DELETE /ledger_accounts/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/ledger_accounts/${primaryId}`);
    }

    /**
     * Calls POST /ledger_accounts/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiLedgerAccount>> {
        return this.http.post<Result<ApiLedgerAccount>, undefined>(`/ledger_accounts/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /ledger_accounts/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiLedgerAccount>>> {
        return this.http.post<Result<LockedContextDto<ApiLedgerAccount>>, undefined>(`/ledger_accounts/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /ledger_accounts/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiLedgerAccount[]>> {
        return this.http.post<Result<ApiLedgerAccount[]>, string[]>('/ledger_accounts/locks', ids);
    }

    /**
     * Calls POST /ledger_accounts/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/ledger_accounts/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /ledger_accounts/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/ledger_accounts/${primaryId}/locks`);
    }
}
